import {BaseService} from "./BaseService";
import {Event} from '../entities/Event'
import { StateService } from "@uirouter/angularjs";

export class EventService extends BaseService<Event>{
    static $inject = ['$http','$q', '$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Event);
    }
    protected getBaseUrl():string{
        return "event";
    }
}
